import I18n from 'i18n-js'
import { isCharacters, isEmail, isEmpty, isPhoneNumber } from './validator'

const CoordinatingStaffValidator = (data, currentField, oldErrors) => {
  let errors = {}

  // name
  if (isEmpty(data.name)) errors.name = I18n.t('validators.required')
  else if (!isCharacters(data.name)) errors.name = I18n.t('validators.name')

  // lastname (optional)
  if (!isEmpty(data.lastname) && !isCharacters(data.lastname))
    errors.lastname = I18n.t('validators.lastname')

  // email (isEmail returns true when INVALID)
  if (isEmpty(data.email)) errors.email = I18n.t('validators.required')
  else if (isEmail(data.email)) errors.email = I18n.t('validators.invalidEmail')

  // phone (optional)
  if (!isEmpty(data.phone) && !isPhoneNumber(data.phone))
    errors.phone = I18n.t('validators.invalidPhone')

  // centers
  if (
    !Array.isArray(data.medical_center_ids) ||
    data.medical_center_ids.length < 1
  )
    errors.medical_center_ids = I18n.t('coordinatingStaff.minOneCenter')

  return {
    errors: currentField
      ? {
          ...oldErrors,
          [currentField]: errors[currentField],
        }
      : {
          ...errors,
        },
    valid: Object.keys(errors).length === 0,
  }
}

export default CoordinatingStaffValidator
